export default "__VITE_ASSET__uU$G8EX8__"